import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { ResponsiveStyle } from '../../../core/StyledComponent';
interface TabPanelProps extends ResponsiveStyle {
    children?: React.ReactNode;
    currentTab: number | string;
    value: number | string;
}

const TabPanel: React.FC<PropsWithChildren<TabPanelProps>> = (props) => {
    const { children, value, currentTab, ...restProps } = props;
    return (
        <Box hidden={value !== currentTab} {...restProps}>
            {value === currentTab && <Box>{children}</Box>}
        </Box>
    );
};

export default TabPanel;
